'use client';

import type { ReactNode } from 'react';

import { IoPushOutline } from 'react-icons/io5';

import type { BaseComponentProps } from '../../base-component.types';
import { Button } from '../../button';
import { ResourceBar } from '../../resource';

import styles from './SubmitBar.module.scss';

type SubmitBarProps = BaseComponentProps & {
  children?: ReactNode;
  isSubmitting?: boolean;
  /** Held back for a reason of the resource's own, with nothing in flight. */
  disabled?: boolean;
  label?: string;
  onSubmit: () => void;
};

/** The bar a resource that is finished from is tailed with. */
function SubmitBar({
  style,
  className,
  children,
  isSubmitting = false,
  disabled = false,
  label = 'Terminar y enviar',
  onSubmit,
  testId,
}: SubmitBarProps) {
  return (
    <ResourceBar
      style={style}
      className={className}
      edge="bottom"
      layout="split"
      testId={testId}
      start={children}
      end={
        <Button
          className={styles['button']}
          loading={isSubmitting}
          disabled={isSubmitting || disabled}
          onClick={onSubmit}
          suffixIcon={<IoPushOutline />}
        >
          {label}
        </Button>
      }
    />
  );
}

export { SubmitBar };
